import React, { useRef } from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRow from '../elements/InputRow'
import FancySelectAdvancedRow from '../elements/FancySelectAdvancedRow'
import Addressify from '../elements/Addressify'
import { useMedia } from 'react-use'

const options = {
    postUrl: '/api/postOrderModem',
    success: 'Success! Your modem order has been completed.'
}
const state = {
    broadbandServiceId: '',
    voipServiceId: '',
    deliveryRecipient: '',
    deliveryAddress: '',
    modemSelected: false,
    extenderOrdered: 0
}

const OrderModemForm = (props) => {
    const isMobile = useMedia('(max-width: 992px)')
    const modemRef = useRef(null)
    const extenderRef = useRef(null)

    const handleToggleModem = event => {
        event.preventDefault()
        props.setDynamicValues({
            modemSelected: !props.values.modemSelected
        })
    }

    const handleToggleExtender = event => {
        event.preventDefault()
        props.setDynamicValues({
            extenderOrdered: props.values.extenderOrdered > 0 ? 0 : 1
        })
    }

    const handleShowMore = ref => {
        if (ref.current) {
            ref.current.style.display = 'block'
        }
    }

    const calcTotal = () => {
        let total = 0
        if (props.values.extenderOrdered > 0) {
            total += props.values.extenderOrdered * 120
        }
        if (props.values.modemSelected) {
            total += 170
        }

        return total
    }

    const ModemList = (
        <ul className='m-0'>
            <li className='bold'>nbn™ approved</li>
            <li className='bold'>Preconfigured for data & voice</li>
            <li className='bold'>Use with your existing telephone</li>
        </ul>
    )

    const ExtenderList = (
        <ul className='m-0'>
            <li className='bold'>EasyMesh standard to provide whole home Wi-Fi coverage</li>
            <li className='bold'>Sleek styling that blends perfectly with your home</li>
        </ul>
    )

    const AddModem = (
        <React.Fragment>
            <svg width='20px' height='20px' viewBox='0 0 30 30' className='mr-2'>
                <rect fill='#004346' x='13' y='7' width='4' height='16' />
                <rect fill='#004346' transform='translate(15.000000, 15.000000) rotate(-90.000000) translate(-15.000000, -15.000000) ' x='13' y='7' width='4' height='16' />
            </svg>
            <span>Add WiFi modem</span>
        </React.Fragment>
    )

    const AddExtender = (
        <React.Fragment>
            <svg width='20px' height='20px' viewBox='0 0 30 30' className='mr-2'>
                <rect fill='#004346' x='13' y='7' width='4' height='16' />
                <rect fill='#004346' transform='translate(15.000000, 15.000000) rotate(-90.000000) translate(-15.000000, -15.000000) ' x='13' y='7' width='4' height='16' />
            </svg>
            <span>Add WiFi extender</span>
        </React.Fragment>
    )

    return (
        <form onSubmit={props.handleSubmit} onKeyDown={props.handleKeyDown}>
            <div className='row mb-2'>
                <div className='col-12 d-flex flex-wrap flex-lg-nowrap'>
                    <div className={`product mr-lg-3 mb-3 mb-lg-0 ${props.values.modemSelected ? 'active' : ''}`}>
                        <div>
                            <span className='bold'>{isMobile ? 'WiFi Modem' : 'Gigabit WiFi-6 MESH 1800Mbps Modem'}</span> <small>(valued at $200)</small>
                        </div>
                        <div>
                            <div className='row align-items-center'>
                                <div className='col-12 col-lg-6'>
                                    <span className='bold font-xlarge'>$170</span> <span className='font-large'>/ Upfront</span>
                                    <br />
                                    <span className='font-tiny'>(Free shipping)</span>
                                </div>
                                <div className='d-none d-lg-block col-12 col-lg-6 text-right'>
                                    Easy set-up. Plug & play.
                                </div>
                            </div>
                            <div className='row align-items-lg-center mt-4 mb-4'>
                                <div className='col-8'>
                                    <p className='m-0'>
                                        The Exetel ZTE modem provides full remote diagnostics and support for your nbn™/Fibre service. <span className='d-lg-none underline' onClick={() => handleShowMore(modemRef)}>more</span>
                                    </p>
                                    <div className='d-none d-lg-block mt-2'>{ModemList}</div>
                                </div>
                                <div className='col-4 text-center'>
                                    <img src='/images/broadband-zte-modem.png' alt='Exetel ZTE broadband modem' width='80px' />
                                </div>
                                <div ref={modemRef} className='col-12 d-lg-none mt-2' style={{ display: 'none' }}>
                                    {ModemList}
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12 px-lg-5 text-center'>
                                    <Button title={props.values.modemSelected ? 'Selected' : AddModem} action={handleToggleModem} className='w-100 d-flex align-items-center justify-content-center' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`product ${props.values.extenderOrdered > 0 ? 'active' : ''}`}>
                        <div>
                            <span className='bold'>{isMobile ? 'WiFi Extender' : 'Gigabit WiFi-6 MESH 1800Mbps Extender'}</span> <small>(valued at $150)</small>
                        </div>
                        <div>
                            <div className='row align-items-center'>
                                <div className='col-12 col-lg-6'>
                                    <span className='bold font-xlarge'>$120</span> <span className='font-large'>/ Upfront</span>
                                    <br />
                                    <span className='font-tiny'>(Free shipping)</span>
                                </div>
                                <div className='d-none d-lg-block col-12 col-lg-6 text-right'>
                                    Need better WiFi coverage?
                                </div>
                            </div>
                            <div className='row align-items-lg-center mt-4 mb-4'>
                                <div className='col-8'>
                                    <p className='m-0'>
                                        The Exetel ZTE WiFi Extender provides whole of home WiFi coverage for your nbn™/Fibre service. <span className='d-lg-none underline' onClick={() => handleShowMore(extenderRef)}>more</span>
                                    </p>
                                    <div className='d-none d-lg-block mt-2'>{ExtenderList}</div>
                                </div>
                                <div className='col-4 text-center'>
                                    <img src='/images/broadband-zte-extender.png' alt='Exetel ZTE broadband extender' width='80px' />
                                </div>
                                <div ref={extenderRef} className='col-12 d-lg-none mt-2' style={{ display: 'none' }}>
                                    {ExtenderList}
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12 px-lg-5 text-center'>
                                    <Button title={props.values.extenderOrdered > 0 ? 'Selected' : AddExtender} action={handleToggleExtender} className='w-100 d-flex align-items-center justify-content-center' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-12 col-md-8 offset-md-2'>
                    <FancySelectAdvancedRow
                        label='Preconfigure for broadband'
                        name='broadbandServiceId'
                        placeholder='Select your broadband service address'
                        value={props.values.broadbandServiceId}
                        errors={props.errors}
                        options={props.broadbandServices}
                        handleChange={props.setDynamicValues}
                    />
                    {props.voipServices.length > 0
                        ? <FancySelectAdvancedRow
                                label='Preconfigure for VoIP'
                                name='voipServiceId'
                                placeholder='Select your Home Phone service no.'
                                value={props.values.voipServiceId}
                                errors={props.errors}
                                options={props.voipServices}
                                handleChange={props.setDynamicValues}
                          />
                        : ''}
                    <InputRow
                        label='Delivery recipient'
                        name='deliveryRecipient'
                        value={props.values.deliveryRecipient}
                        errors={props.errors}
                        handleChange={props.handleInputChange}
                        placeholder='Name of person accepting delivery'
                    />
                    <Addressify
                        label='Delivery address'
                        name='deliveryAddress'
                        value={props.values.deliveryAddress}
                        errors={props.errors}
                        handleSetAddress={props.setDynamicValues}
                        placeholder='Start typing your delivery address'
                    >
                        <small>We can't deliver to a PO Box</small>
                    </Addressify>

                    {props.children}

                    <div className='mt-4 w-100 text-center text-md-left'>
                        <Button title='Place Order' action={props.handleSubmit} />
                    </div>
                </div>
            </div>
        </form>
    )
}

export default FormHOC(OrderModemForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/OrderModemForm.js